import { createSvgIcon } from "@material-ui/core/utils";
import React from "react";

export const ProductIcon = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M5.22559 5.62861C5.37745 5.24895 5.74516 5 6.15407 5H17.8459C18.2548 5 18.6225 5.24895 18.7744 5.62861L19.523 7.5H4.47703L5.22559 5.62861ZM15.5 9.5H20V18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18V9.5H8.5V14.4597C8.5 15.7174 9.9549 16.4167 10.937 15.631L12 14.7806L13.063 15.631C14.0451 16.4167 15.5 15.7174 15.5 14.4597V9.5ZM13.5 9.5H10.5V13.4194L11.063 12.969C11.6108 12.5307 12.3892 12.5307 12.937 12.969L13.5 13.4194V9.5ZM6.15407 3C4.92735 3 3.82423 3.74685 3.36864 4.88583L2 8.30742V18C2 19.6569 3.34315 21 5 21H19C20.6569 21 22 19.6569 22 18V8.30742L20.6314 4.88583C20.1758 3.74685 19.0726 3 17.8459 3H6.15407Z"
    fill="currentColor"
  />,
  "ProductIcon"
);
